import React from 'react';
import Trash from '../../../icons/trash';

interface LegifrancePopoverProps {
  code: string;
  section: string;
  article: string;
  onRemove: () => void;
  position: { top: number; left: number };
}

const LegifrancePopover: React.FC<LegifrancePopoverProps> = ({
  code,
  section,
  article,
  onRemove,
  position
}) => {
  const displayText = `${code}${section ? `, ${section}` : ''}${article ? `, ${article}` : ''}`;

  return (
    <div
      className="absolute z-50 bg-mcdm-primary-100 dark:bg-mcdm-primary-100 border border-gray-300 rounded shadow-md p-2 min-w-[200px]"
      style={{ top: `${position.top}px`, left: `${position.left}px` }}
    >
      <p className="mb-2 text-sm text-mcdm-third-500">
        <strong>Texte juridique :</strong>{' '}
        {displayText}
      </p>
      <button
        onClick={onRemove}
        className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white text-sm py-1 px-2 rounded"
      >
        <Trash width="14px" height="14px" fill="white" />
        Supprimer la référence
      </button>
    </div>
  );
};

export default LegifrancePopover;
